// Aqui customizamos as mensagens de erro
// TODO: inspecine o error e perceba as propriedades que vc pode usar
export const defaultErrors = {
  'Mask error': (error) => null,
  required: (error) => 'Por favor, preencha',
  email: (error) => 'Por favor, insira um email válido',
  pattern: (error) => 'Por favor, insira um formato válido',
  maxlenght: (error) => 'Quantidade de caracteres excedido',
  minlength: (error) => 'Quantidade de caracteres insuficiente',
  nomeCompletoMinimoDeLetras: (error) => 'Por favor, insira um formato válido',
  cnpjInvalido: (error) => 'Por favor, insira um CNPJ valido',
  cpfInvalido: (error) => 'Por favor, insira um CPF valido',
  senhasNaoCoincidem: (error) => 'As senhas não correspondem'
  // colocar os demais possiveis erros e mensagens aqui*/
};
